
export function Success() {
    return (
        <div>
            Success!
        </div>
    )
}